import { FormEvent, useContext, useState } from 'react'

// context
import { AppContext } from '../../App'

// components
import StepCard from '../step-card/step-card'

// styles
import Button from '../button/button'
import Footer from '../footer/footer'
import Field from '../forms/field/field'
import styles from './login.module.scss'

const Login = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const [error, setError] = useState(false)

	const formSubmit = (e: FormEvent) => {
		e.preventDefault()
		const usernameField: HTMLInputElement | null =
			e.currentTarget.querySelector('input[name="username"]')
		// const emailField: HTMLInputElement | null =
		// 	e.currentTarget.querySelector('input[name="email"]')

		let error = false
		if (usernameField?.value !== 'admin') error = true
		// if (!error) {
		// 	if (emailField?.value !== 'admin@tgl.com') error = true
		// }

		setError(error)

		if (!error) {
			appContext?.setLoggedIn(!error)
		}
	}

	return (
		<>
			<main className={styles.login}>
				<StepCard
					stepTitle="Login"
					className={[styles.card, 'animate-appear'].join(' ').trim()}
				>
					<form onSubmit={formSubmit}>
						<Field
							type="text"
							required
							label="Username"
							name="username"
						/>
						<Field
							type="email"
							required
							label="Email"
							name="email"
						/>

						{error && (
							<p className={styles.error}>
								Username and Password do not match.
							</p>
						)}

						<Button type="submit" theme="primary" label="Login" />
					</form>
				</StepCard>
			</main>
			<Footer className={styles.footer} />
		</>
	)
}

export default Login
